// @ts-nocheck
import * as React from "react";

const CheckmarkSquare2Line: React.FC = () => {
    return (
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path
                d="M18 3a3 3 0 013 3v12a3 3 0 01-3 3H6a3 3 0 01-3-3V6l.005-.176A3 3 0 016 3zm0 2H6a1 1 0 00-1 1v12l.007.117A1 1 0 006 19h12a1 1 0 001-1V6a1 1 0 00-1-1zm-3.227 3.294A1.006 1.006 0 0116.29 9.61l-4.57 6a1 1 0 01-.79.39l-.13-.008a1 1 0 01-.66-.372l-2.43-3.11-.071-.104A1.001 1.001 0 019.29 11.28l1.63 2.11 3.78-5h-.01z"
                fill="currentColor"
                fillRule="evenodd"
            />
        </svg>
    );
};

export default React.memo(CheckmarkSquare2Line);
